import { render, staticRenderFns } from "./lawyer_box.vue?vue&type=template&id=1188de68&scoped=true"
import script from "./lawyer_box.vue?vue&type=script&lang=js"
export * from "./lawyer_box.vue?vue&type=script&lang=js"
import style0 from "./lawyer_box.vue?vue&type=style&index=0&id=1188de68&prod&scoped=true&lang=less"
import style1 from "./lawyer_box.vue?vue&type=style&index=1&id=1188de68&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1188de68",
  null
  
)

export default component.exports